import { MessageSquare, Sparkles, TrendingUp } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const identifyFeatureGapProductLedUpsellAr: TemplateAr = {
  name: 'رصد فجوة الميزات + بيع إضافي مدفوع بالمنتج',
  description:
    'الذكاء الاصطناعي يرصد طلب العملاء لميزات متقدمة ويُطلق عروض البيع الإضافي في لحظة الحاجة نفسها.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: MessageSquare, label: 'طلب ميزة' },
    { icon: Sparkles, label: 'الـ AI يرصد الفجوة' },
    { icon: TrendingUp, label: 'عرض ترقية', final: true },
  ],
  detailDescription: {
    paragraph1:
      'لمّا يطلب العميل ميزة موجودة في باقة أعلى، اعرض عليه الترقية وقتها. الـ AI يعرف إشارات فجوة الميزات — طلبات القدرات المتقدمة، أو الحلول الالتفافية للقيود، أو الأسئلة عن الميزات المتقدمة. ويعرض الترقية في اللحظة اللي يدرك فيها العميل أنه يحتاج أكثر، فيرفع التحويل لأقصى حد.',
    paragraph2:
      'تتابع بيانات فجوة الميزات ونتائج البيع الإضافي في أدوات تحليلات المنتج والإيرادات عندك. والـ AI يتعلّم أي الميزات تدفع للترقية أكثر، ويقدّمها في أولويات تطوير المنتج. والبيع الإضافي اللي ينجح يشغّل فتح المزايا وسير عمل إعداد الترقية تلقائياً.',
  },
  benefits: [
    'حوّل العميل في نفس اللحظة اللي يحتاج فيها الميزة',
    'نمو مدفوع بالمنتج يشتغل بنفسه',
    'طلبات الميزات عالية القيمة تطلع لك',
    'الوقت بين طلب الميزة والترقية ينزل',
    'خارطة طريق منتجك تجيها بيانات إيراد حقيقية',
    'إيراد التوسّع يزيد تلقائياً',
  ],
};
